// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-success-container {
    text-align: center;
    padding: 20px;
  }
  
  .payment-success-container h1 {
    color: #333;
  }
  
  .payment-success-container p {
    font-size: 16px;
    color: #555;
  }
  
  .payment-success-container a {
    color: #007bff;
    text-decoration: none;
  }
  
  .payment-success-container a:hover {
    text-decoration: underline;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/SIBS/SIBS.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":[".payment-success-container {\r\n    text-align: center;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .payment-success-container h1 {\r\n    color: #333;\r\n  }\r\n  \r\n  .payment-success-container p {\r\n    font-size: 16px;\r\n    color: #555;\r\n  }\r\n  \r\n  .payment-success-container a {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n  }\r\n  \r\n  .payment-success-container a:hover {\r\n    text-decoration: underline;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
